import { api } from "../api";

/*
 * Service utilisé pour les formulaires dynamiques
 */

export function getFormulaireDynamique(idFormulaireDynamique = "") {
  return api.get("FormulaireDynamique/GetFormulaireDynamique?idFormulaireDynamique=" + idFormulaireDynamique);
}

export function getFormulaireCampJourWeb() {
  return api.get("Formulaire/FormulaireCampJourWeb");
}

export function getFormulaireInscriptionByIdCampInscription(idCampInscription) {
  return api.get("Formulaire/FormulaireInscription/" + idCampInscription);
}

export function resolveIdCampInscriptionList(cacheKey, idFromUrl) {
  let listFromCache = [];
  try {
    const cached = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(cacheKey) : null;
    const parsed = cached ? JSON.parse(cached) : null;
    listFromCache = Array.isArray(parsed) ? parsed : (parsed?.idCampInscriptionList || []);
  } catch (e) {
    listFromCache = [];
  }
  const hasValidList = listFromCache.length > 0;
  const urlIdInvalid = idFromUrl && hasValidList &&
    !listFromCache.some(id => String(id) === String(idFromUrl));
  const list = urlIdInvalid ? [] : (hasValidList ? listFromCache : (idFromUrl ? [idFromUrl] : []));
  return { list, urlIdInvalid };
}

export async function fetchFormulairesInscriptionData(list) {
  if (!list || list.length === 0) {
    return { noData: true };
  }
  const responses = await Promise.all(
    list.map(id => getFormulaireInscriptionByIdCampInscription(id))
  );

  return responses;
}

export function buildSaveFormulaireInscriptionPayload(
  formData,
  idCampInscription,
  currentForm,
  currentChildStep
) {
  const details = (currentForm?.details ?? []).filter(
    (field) => field.typeChamp !== 0 && field.typeChamp !== 11 && field.typeChamp !== 12
  );
  const inscriptions = currentForm.inscriptions ?? [];
  const inscriptionsToSend = [];

  details.forEach((field) => {
    const idDetail = field.idFormulaireDetail;
    if (!idDetail) return;
    const fieldKey = `enfant${currentChildStep + 1}_${idDetail}`;
    const valeur = formData[fieldKey];
    const valeurStr = valeur === undefined || valeur === null ? '' : String(valeur).trim();

    const existing = inscriptions.find(
      (i) => i.idFormulaireDetail === idDetail
    );

    if (existing) {
      inscriptionsToSend.push({
        ...existing,
        valeur: valeurStr
      });
    } else {
      inscriptionsToSend.push({
        idFormulaireDetail: idDetail,
        valeur: valeurStr,
        typeAuxiliaire: 'CJ',
        idAuxiliaire: idCampInscription
      });
    }
  });

  // Old logic: only send non-empty, changed inscriptions
  // details.forEach((field) => {
  //   const idDetail = field.idFormulaireDetail;
  //   if (!idDetail) return;
  //   const fieldKey = `enfant${currentChildStep + 1}_${idDetail}`;
  //   const valeur = formData[fieldKey];
  //   const valeurStr = valeur === undefined || valeur === null ? '' : String(valeur).trim();
  //   if (valeurStr === '') return;
  //
  //   const existing = inscriptions.find(
  //     (i) => i.idFormulaireDetail === idDetail
  //   );
  //   const currentValeur = existing?.valeur != null ? String(existing.valeur).trim() : '';
  //   if (valeurStr === currentValeur) return;
  //
  //   if (existing) {
  //     inscriptionsToSend.push({ ...existing, valeur: valeurStr });
  //   } else {
  //     inscriptionsToSend.push({
  //       idFormulaireDetail: idDetail,
  //       valeur: valeurStr,
  //       typeAuxiliaire: 'CJ',
  //       idAuxiliaire: idCampInscription
  //     });
  //   }
  // });

  const { details: _details, ...rest } = currentForm;
  return { ...rest, inscriptions: inscriptionsToSend };
}

export function saveFormulaireInscription(payload) {
  return api.post("Formulaire/SaveFormulaireInscription", JSON.stringify(payload));
}